// Symplur footer
jQuery(document).ready(function() {
	var Cookies = require("js-cookie");

	if (window.location.hostname != 'www.symplur.com') {
		var cookieName = 'symplur-login-dev';
	} else {
		var cookieName = 'symplur-login';
	}

	if (!!Cookies.get(cookieName)) {
		return jQuery.ajax({
			type: "POST",
			url: '/account/identify',
			dataType: 'json',
			data: { cookie: Cookies.get(cookieName)},
			success: function(data)
			{
				if (data['status'] === 'success') {
					window.symplurIntercomUserHash = data['intercomUserHash'];
					analytics.identify(data['userId'], {},
					{
						integrations: {
							Intercom : {
								user_hash: data['intercomUserHash']
							}
						}
					});
					return true;
				} else {
					return false;
				}
			}
		});
	}
});
